// Mock data for Fuzz landing page

export const heroData = {
  tagline: "Never miss a hello again.",
  subtitle: "Fuzz helps you connect with people nearby, stay synced with your trusted circle, and feel safe wherever you are.",
  ctaButtons: [
    { text: "Get Early Access", type: "primary" },
    { text: "Download App", type: "secondary" }
  ]
};

export const trustBar = {
  stats: [
    { icon: "star", text: "Loved by early communities" },
    { icon: "map-pin", text: "Built for real-world connection" },
    { icon: "shield-check", text: "Privacy-first design" }
  ]
};

export const features = [
  {
    id: "fuzz",
    name: "Fuzz",
    title: "Fuzz the people around you.",
    description: "See trusted or familiar people nearby and send a quick wave — a lightweight way to say hello without awkward texting.",
    highlights: [
      "Social proximity",
      "Real-life moments",
      "Friendly, playful interaction"
    ],
    color: "teal"
  },
  {
    id: "vibe",
    name: "Vibe",
    title: "Your Vibe is your secure circle.",
    description: "Create private groups with close friends and family. Mark safe zones and stay connected without constant calling.",
    safeZones: [
      { icon: "home", label: "Home" },
      { icon: "school", label: "School" },
      { icon: "building", label: "Office" },
      { icon: "map-pin", label: "Custom places" }
    ],
    highlights: [
      "Private groups",
      "Safe zone alerts",
      "Peace of mind"
    ],
    color: "green"
  },
  {
    id: "sos",
    name: "SOS",
    title: "SOS when it matters most.",
    description: "Activate SOS to instantly alert your trusted emergency group. Live location is shared immediately, your circle is notified, and help can reach you faster.",
    highlights: [
      "Instant emergency alerts",
      "Live location sharing",
      "Fast response"
    ],
    color: "coral"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Fuzz nearby people",
    description: "Discover and wave at friends who are close by"
  },
  {
    step: 2,
    title: "Build your Vibe circle",
    description: "Create secure groups with trusted contacts"
  },
  {
    step: 3,
    title: "Stay safe with SOS",
    description: "Emergency support at your fingertips"
  }
];

export const useCases = [
  {
    title: "For Families",
    description: "Peace of mind through safe zones",
    icon: "users"
  },
  {
    title: "For Friends",
    description: "Real-life proximity made social",
    icon: "user-heart"
  },
  {
    title: "For Safety",
    description: "SOS support instantly",
    icon: "shield-alert"
  },
  {
    title: "For Students",
    description: "Stay connected on campus",
    icon: "graduation-cap"
  }
];

export const testimonials = [
  {
    quote: "Fuzz makes cities feel smaller in the best way.",
    author: "Aman",
    location: "Dubai"
  },
  {
    quote: "Vibe circles are like a safety net, not surveillance.",
    author: "Muskan",
    location: "Mumbai"
  },
  {
    quote: "The wave feature is genius — so lightweight and human.",
    author: "Karan",
    location: "Delhi"
  },
  {
    quote: "I feel safer knowing my family can reach me instantly with SOS.",
    author: "Priya",
    location: "Bangalore"
  },
  {
    quote: "Finally, a proximity app that doesn't feel creepy.",
    author: "Rohan",
    location: "Pune"
  },
  {
    quote: "Love how I can see my friends nearby without constant texting.",
    author: "Sara",
    location: "Dubai"
  }
];

export const privacyPoints = [
  "Only trusted circles",
  "No selling location data",
  "Full control over visibility",
  "Designed for comfort, not stalking"
];

export const footerLinks = {
  company: [
    { label: "About Fuzz", href: "/about" },
    // { label: "Careers", href: "#careers" },
    { label: "Contact", href: "/contact" }
  ],
  legal: [
    { label: "Privacy Policy", href: "/privacy-policy" },
    { label: "Terms of Service", href: "/terms" }
  ],
  features: [
    { label: "Fuzz Nearby", href: "#fuzz" },
    { label: "Vibe Circles", href: "#vibe" },
    { label: "SOS Safety", href: "#sos" }
  ]
};
